module.exports = __webpack_public_path__ + "static/img/eval-cover.e6ff78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/eval-cover.png
// module id = qkHg
// module chunks = 2